import {useEffect, useState} from 'react';

export default function useFloatingContactActions(cardRef, ready) {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const card = cardRef.current;
    if (!ready || !card) {setVisible(false); return;}
    const update = () => {
      const navHeight = document.querySelector('.bb-bottom-nav')?.getBoundingClientRect().height || 0;
      setVisible(window.innerWidth < 992 && card.getBoundingClientRect().top >= window.innerHeight - navHeight);
    };
    update();
    const observer = typeof IntersectionObserver !== 'undefined' ? new IntersectionObserver(update) : null;
    observer?.observe(card);
    window.addEventListener('resize', update);
    // Also handle scrolling past the card and back above it, including older browsers.
    window.addEventListener('scroll', update, {passive:true});
    return () => {
      observer?.disconnect();
      window.removeEventListener('resize', update);
      window.removeEventListener('scroll', update);
    };
  }, [cardRef, ready]);
  return ready && visible;
}
